import React from 'react';
import NoImageFoundDocument from '../thumbnail/noImageFoundDocument';

const ImagePreviewComponent = ({ file, rearFile, breakPage }: any) => {
    return (
        <div style={{ paddingTop: "20px" }} className={breakPage ? "image-container" : ""}>
            <div
                style={{
                    width: "auto",
                    height: "auto",
                    overflow: "hidden",
                    position: "relative",
                }}
            >
                <img
                    style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        overflow: "hidden",
                    }}
                    src={file?.fileUrl}
                />
            </div>

            <div
                style={{
                    width: "auto",
                    height: "auto",
                    overflow: "hidden",
                    position: "relative",
                    paddingTop: "20px"
                }}
            >
                {rearFile != undefined && rearFile != null ?
                    <img
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            overflow: "hidden",
                        }}
                        src={rearFile.fileUrl}
                    /> :
                    <img
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            overflow: "hidden",
                        }}
                        src="/images/noImageFound.svg"
                        alt="Forest"

                    />}
            </div>



        </div>
    );
};

export default ImagePreviewComponent;